// features/user/userApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const RulesApi = createApi({
  reducerPath: "RulesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "rules_and_regulations",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getRules: builder.query({
      query: () => ({
        url: "",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetRulesQuery } = RulesApi;
// for use just enter the page name
